export default "__VITE_ASSET__BeN0b4sE__"